import './ServiceRequest.css';

import ServiceRequestAuthorizedUser from './ServiceRequestAuthorizedUser/ServiceRequestAuthorizedUser';
import ServiceRequestChangeAddress from './ServiceRequestChangeAddress/ServiceRequestChangeAddress';
import ServiceRequestChangePhone from './ServiceRequestChangePhone/ServiceRequestChangePhone';
import ServiceRequestCreateBankMandate from './ServiceRequestCreateBankMandate/ServiceRequestCreateBankMandate';
import ServiceRequestEarlyPayment from './ServiceRequestEarlyRepayment/ServiceRequestEarlyRepayment';
import ServiceRequestLogBook from './ServiceRequestLogBook/ServiceRequestLogBook';
import ServiceRequestManageDelegate from './ServiceRequestManageDelegate/ServiceRequestManageDelegate';
import ServiceRequestObjectChange from './ServiceRequestObjectChange/ServiceRequestObjectChange';
import {formatServiceRequestDate} from './ServiceRequestDashboard/serviceRequestDashboardHelper';
import ServiceRequestSettlementQuote from './ServiceRequestSettlementQuote/ServiceRequestSettlementQuote';

import AssetSearchOption from '../../lib/AssetSearchOption/AssetSearchOption';
import SelectWidget from '../../lib/SelectWidget/SelectWidget';
import {
  getServiceRequestDetailsAction,
  getServiceRequestInfoAction,
  incorrectDataNameAction,
  pushViewAction,
  serviceRequestErrorAction,
  serviceRequestLoaderAction,
} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import {getAPICall} from '../../services/apiCallsHandler';
import {
  GERMANY_COUNTRY_CODE,
  Lease_Settlement_Quote_Allowed_List,
  SERVICE_REQUEST_TYPE_BY_VIEW,
  UK_COUNTRY_CODE,
} from '../../utils/constant';
import {isServiceRequestAllowed} from '../../utils/roleAccess';
import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';
import ContractYearDropdown from '../contractYearDropdown/contractYearDropdown';
import CurrentlyUnavailableCard from '../currently_unavailable_div/CurrentlyUnavailableCard';
import EquipmentModelsView from '../EquipmentViewPopup/EquipmentModelsView/EquipmentModelsView';
import ViewAssetsButton from '../EquipmentViewPopup/ViewAssetsButton/ViewAssetsButton';
import SkeletonLoader from '../skeletonLoader/SkeletonLoader';

import {Alert, Box, Button, Card, CardContent} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

export const getServiceRequestTypes = ({
  country,
  contracts,
  contractDetailsError,
  roleAccess,
}) => [
  {
    label: 'LOG_BOOK_REQUEST',
    value: 'logBookRequest',
    hidden: contractDetailsError?.isError || country !== GERMANY_COUNTRY_CODE,
  },
  {
    label: 'OBJECT_CHANGE_REQUEST',
    value: 'objectChange',
    hidden: contractDetailsError?.isError || country !== GERMANY_COUNTRY_CODE,
  },
  {
    label: 'PARTIAL_EARLY_REPAYMENT_LOAN',
    value: 'partialRepayment',
    hidden:
      contracts?.length <= 0 ||
      [UK_COUNTRY_CODE, GERMANY_COUNTRY_CODE].includes(country),
  },
  {
    label: 'SETTLEMENT_QUOTE',
    value: 'settlementQuote',
    hidden:
      contracts?.length <= 0 ||
      !contracts?.find((contract) =>
        Lease_Settlement_Quote_Allowed_List[country]?.includes(
          contract.productLine
        )
      ),
  },
  {label: 'CHANGE_PHONE_NUMBER', value: 'changePhone', hidden: false},
  {label: 'CHANGE_EMAIL_ID', value: 'changeEmail', hidden: false},
  {label: 'CHANGE_ADDRESS', value: 'changeAddress', hidden: false},
  {
    label: 'CHANGE_DIRECT_DEBIT',
    value: 'createBankMandate',
    hidden:
      roleAccess?.CHANGE_DIRECT_DEBIT === undefined
        ? false
        : !roleAccess.CHANGE_DIRECT_DEBIT,
  },
  {
    label: 'AUTHORIZED_USER_MANAGE',
    value: 'authorizedUserManage',
    hidden: false,
  },
  {label: 'MANAGE_DELEGATE', value: 'manageDelegate', hidden: false},
];

const ServiceRequest = (prop) => {
  const [serviceRequests, setServiceRequests] = React.useState({
    myRequests: [],
    allRequests: [],
  });
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(null);
  const [displayContractDorpDown, setDisplayContractDorpDown] =
    React.useState(false);

  const [selectedContractNumber, setSelectedContractNumber] =
    React.useState(null);
  const [selectedParty, setSelectedParty] = React.useState(null);
  const [displayPersonalNote, setDisplayPersonalNote] = React.useState(false);
  const [assetContractOption, setAssetContractOption] = React.useState(null);
  const [showAllContract, setShowAllContract] = React.useState(false);
  const [contractFilterBy, setContractFilterBy] = React.useState([]);
  const {t} = useTranslation();

  const isRestrictedForRole = (value) =>
    !isServiceRequestAllowed(
      prop.role,
      SERVICE_REQUEST_TYPE_BY_VIEW[value],
      prop.roleAccess
    );
  const dropDownItem = getServiceRequestTypes({
    country: prop.country,
    contracts: prop.contractNumber?.contracts,
    contractDetailsError: prop.contractDetailsError,
    roleAccess: prop.roleAccess,
  })
    .map((item) => ({
      ...item,
      label: t(item.label),
      hidden: item.hidden || isRestrictedForRole(item.value),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  React.useEffect(() => {
    setSelectedParty(prop.selectedOrg);
    setDisplayPersonalNote(false);
  }, [prop.contractNumber, prop.selectedOrg]);

  React.useEffect(() => {
    if (prop.requestType) {
      setSelectedItemIndex(
        dropDownItem.filter((i) => i.value === prop.requestType)[0].value
      );
      appStore.dispatch(incorrectDataNameAction(null));
    }
  }, [prop.requestType]);

  // Helper function to get personal contract value
  const getPersonalContractValue = () => {
    if (prop.personal?.accounts?.length > 0) {
      return prop.personal.accounts[0].contractNumber;
    }
    return null;
  };

  // Helper function to get first org contract value
  const getFirstOrgContractValue = () => {
    if (prop.orgs) {
      const firstOrgKey = Object.keys(prop.orgs)[0];
      if (firstOrgKey && prop.orgs[firstOrgKey]?.accounts?.length > 0) {
        return prop.orgs[firstOrgKey].accounts[0].contractNumber;
      }
    }
    return null;
  };

  React.useEffect(() => {
    if (!prop.serviceRequestData) return;

    if (prop.serviceRequestData.selectedRequestType) {
      clickHandler(prop.serviceRequestData.selectedRequestType);
    }

    if (prop.serviceRequestData.selectedContractParty === 'Personal Details') {
      setDisplayPersonalNote(true);
      const personalContractValue = getPersonalContractValue();
      if (personalContractValue) {
        setSelectedContractNumber(personalContractValue);
      } else {
        setSelectedContractNumber('');
      }
      setSelectedParty(null);
    }
  }, [prop.serviceRequestData]);

  // The redirect data is for one visit; keeping it would preselect the same request type next time
  React.useEffect(
    () => () => {
      appStore.dispatch(getServiceRequestInfoAction(null));
    },
    []
  );

  const mapRequests = (requests) =>
    (requests || []).map((request) => ({
      Date: formatServiceRequestDate(request.timestamp),
      Request_Number: request.requestId,
      Type: t(request.requestType.replaceAll(' ', '_')),
      Status: request.requestStatus,
      Customer_Id: request.customerId,
    }));

  React.useEffect(() => {
    sendScreenViewNR('serviceRequest');
    Smartlook.navigation('serviceRequest');
    appStore.dispatch(serviceRequestLoaderAction(true));
    getAPICall(
      `serviceRequest?selectedOrg=${prop.selectedOrg}`,
      {
        isCallBack: false,
        errorTag: 'FETCH_SERVICE_REQUEST',
        redirectToOops: false,
      },
      {
        stateName: 'serviceRequestDetails',
        actionName: getServiceRequestDetailsAction,
      }
    ).then((response) => {
      appStore.dispatch(serviceRequestLoaderAction(false));
      if (response.isError) {
        appStore.dispatch(serviceRequestErrorAction(response));
      } else {
        setServiceRequests({
          myRequests: mapRequests(response.myRequests),
          allRequests: mapRequests(response.allRequests),
        });
      }
    });
  }, []);

  const cancelButtonClick = (value) => {
    setSelectedItemIndex(value);
    setDisplayContractDorpDown(false);
  };

  const VIEWS = {
    changePhone: (
      <ServiceRequestChangePhone
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={
          displayPersonalNote
            ? selectedContractNumber
            : prop.contractNumber?.contracts[0].contractNumber
        }
        selectedParty={selectedParty}
        selectedNumberType={prop.serviceRequestData?.selectedNumberType}
      />
    ),
    changeEmail: (
      <ServiceRequestChangePhone
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={
          displayPersonalNote
            ? selectedContractNumber
            : prop.contractNumber?.contracts[0].contractNumber
        }
        selectedParty={selectedParty}
      />
    ),
    changeAddress: (
      <ServiceRequestChangeAddress
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={
          displayPersonalNote
            ? selectedContractNumber
            : prop.contractNumber?.contracts[0].contractNumber
        }
        selectedParty={selectedParty}
      />
    ),
    settlementQuote: (
      <ServiceRequestSettlementQuote
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={selectedContractNumber}
        selectedParty={selectedParty}
      />
    ),
    partialRepayment: (
      <ServiceRequestEarlyPayment
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={selectedContractNumber}
        selectedParty={selectedParty}
      />
    ),
    logBookRequest: (
      <ServiceRequestLogBook
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={selectedContractNumber}
        selectedParty={selectedParty}
      />
    ),
    objectChange: (
      <ServiceRequestObjectChange
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={selectedContractNumber}
        selectedParty={selectedParty}
      />
    ),
    createBankMandate: (
      <ServiceRequestCreateBankMandate
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={selectedContractNumber}
        selectedParty={selectedParty}
        allContracts={prop.contractNumber}
      />
    ),
    authorizedUserManage: (
      <ServiceRequestAuthorizedUser
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={prop.contractNumber?.contracts[0].contractNumber}
        selectedParty={selectedParty}
      />
    ),
    manageDelegate: (
      <ServiceRequestManageDelegate
        view={selectedItemIndex}
        cancelButtonClick={cancelButtonClick}
        contractNumber={prop.contractNumber?.contracts[0].contractNumber}
        selectedParty={selectedParty}
      />
    ),
  };
  const clickHandler = (value) => {
    setDisplayContractDorpDown(false);
    setSelectedItemIndex(value);

    if (
      value === 'partialRepayment' ||
      value === 'settlementQuote' ||
      value === 'logBookRequest' ||
      value === 'objectChange' ||
      value == 'createBankMandate'
    ) {
      setDisplayContractDorpDown(true);
      if (value == 'settlementQuote') {
        setContractFilterBy(Lease_Settlement_Quote_Allowed_List[prop.country]);
      } else {
        setContractFilterBy([]);
      }
      if (value == 'createBankMandate') {
        setShowAllContract(true);
      } else {
        setShowAllContract(false);
      }
    }
  };

  const contractClickHandler = (value) => {
    setSelectedContractNumber(value);
  };

  const serviceRequestLandingCard = () => (
    <>
      <div className={'ServiceRequestCard service-request-info-icon'}>
        {displayPersonalNote &&
          prop.selectedOrg &&
          (selectedItemIndex === 'changePhone' ||
            selectedItemIndex === 'changeEmail' ||
            selectedItemIndex === 'changeAddress') && (
            <Alert title="" variant="info" id="personal-info-notice">
              {t('SERVICE_REQUEST_MYACCOUNT_REDIRECTION_MSG')}
            </Alert>
          )}
        <div className="serviceRequestHeaderTop">
          <div className="serviceRequestHeader">
            <div className={'Servicetitle'}>{t('SERVICE_REQUEST_TITLE')}</div>
            <div className={'ServiceSubTitle'}>{t('SERVICE_REQUEST_DESC')}</div>
          </div>

          {((typeof prop.roleAccess === 'object' &&
            serviceRequests?.myRequests?.length > 0) ||
            (prop.roleAccess == null &&
              (serviceRequests?.myRequests?.length > 0 ||
                serviceRequests?.allRequests?.length > 0))) && (
            <Button
              id="viewRequests"
              variant="text"
              onClick={() =>
                appStore.dispatch(pushViewAction('serviceRequestDashboard'))
              }
            >
              {t('VIEW_REQUESTS')}
            </Button>
          )}
        </div>
      </div>
      <Box pl={4} pr={4} pb={4}>
        <Card className="cardCustom">
          <CardContent className="cardConentCustom ServiceRequestTypeField">
            <SelectWidget
              id="requestTypeSelect"
              label={t('SELECT_SERVICE_REQUEST_TYPE')}
              placeholder={t('SELECT_SERVICE_REQUEST_TYPE_OPTION')}
              changeHandler={clickHandler}
              data={dropDownItem}
              required={true}
              multiple={false}
              hasSelectAll={false}
              disabled={false}
              value={selectedItemIndex ?? ''}
              defaultValue=""
            />
          </CardContent>
          {displayContractDorpDown && (
            <div className="contractDropdownModelContainer">
              <AssetSearchOption
                setAssetContractOption={setAssetContractOption}
              />
              <div className="contractDropdownContainer">
                <ContractYearDropdown
                  showYear={false}
                  showMonths={false}
                  allContracts={showAllContract}
                  onDropdownChange={(contractNo) =>
                    contractClickHandler(contractNo)
                  }
                  assetContractOption={assetContractOption}
                  contractFilterBy={contractFilterBy}
                />
                <ViewAssetsButton
                  selectedContractNumber={selectedContractNumber}
                />
                <EquipmentModelsView
                  allContracts={showAllContract}
                  selectedContract={selectedContractNumber}
                />
              </div>
            </div>
          )}
        </Card>
      </Box>
      {selectedItemIndex &&
        !isRestrictedForRole(selectedItemIndex) &&
        VIEWS[selectedItemIndex]}{' '}
    </>
  );

  const renderCurrentlyUnavailableCard = () => {
    return (
      <CurrentlyUnavailableCard
        title={t('SOMETHING_WENT_WRONG')}
        subTitle={t('SERV_DASHBOARD_NOT_AVAILABLE')}
        fullScreen={true}
      />
    );
  };

  return (
    <div>
      <Box>
        <div className="serviceRequestWrapper">
          {prop.serviceRequestLoader ||
          prop.contractNumberLoader ||
          prop.contractDetailsLoader ? (
            <SkeletonLoader componentName="ServiceRequestDashboard" />
          ) : prop.serviceRequestError || prop.contractNumberError ? (
            renderCurrentlyUnavailableCard()
          ) : (
            serviceRequestLandingCard()
          )}
        </div>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    requestType: state.appStates.incorrectDataServiceRequest,
    contractNumber: state.appStates.contractNumbers,
    orgs: state.appStates.allContracts?.organisation,
    personal: state.appStates.allContracts?.personal,
    serviceRequestData: state.appStates.serviceRequestRedirectionData,
    selectedOrg: state.appStates.selectedOrg,
    contractNumberLoader: state.appStates.contractNumberLoader,
    contractNumberError: state.appStates.contractNumberError,
    serviceRequestLoader: state.appStates.serviceRequestLoader,
    serviceRequestError: state.appStates.serviceRequestError,
    contractDetailsLoader: state.appStates.contractDetailsLoader,
    country: state.appStates.allContracts?.countryCode,
    contractDetailsError: state.appStates.contractDetailsError,
    role: state.appStates.role,
    roleAccess: state.appStates.roleAccess,
  };
};
export default connect(mapStateToProps)(ServiceRequest);
